<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xi"></a>
<h2 class="fm_title">Acknowledgements</h2>
<p class="noindent"><span class="dropcap">T</span>hanks to all the veterans who gave me their time, their thoughts and their hospitality. One who must be singled out is Major Masao Horie of the 18th Army. Masao was enthused by the idea of this book and has been known to pull rank, when necessary, to persuade a veteran to meet me.</p>
<p class="indent">I am grateful to my Japanese friends for assistance in one, two, three, or all of: finding the veterans, inducing them to talk to me, helping with the interviews and translating them. My friends are Hajime Marutani, Naoko Nakagawa, Yayoi Akaboshi, Go and Yukiko Sato, and in Australia Haruki Yoshida and Tazu Hackett.</p>
<p class="indent">My wife Samantha also deserves credit for finding a veteran. Once, when eating alone at a restaurant at Inuyama, she noticed that a painting on the wall was of the Japanese battleship <em class="italic">Yamato</em>. She found that the restaurant owner had served in the ship, tracked him down and lined up an interview for me the following day.</p>
<p class="indent">Four of the interviews are not mine and one is not an interview. Stig Schnell, Shaun Gibbons and Craig Collie kindly allowed me to use two of the interviews they did for their 2008 documentary <em class="italic">Beyond Kokoda</em>. The veterans are Yukiharu Yamasaki and Yoriichi Yokoyama.</p>
<p class="indent">I am grateful to the Australian War Memorial for permission to use excerpts from two of their interviews from the Australia-Japan Research Project website. The names of these two veterans are Teruo Murakami and Masayoshi Yamada.</p>
<p class="indent">The fifth of the interviews that I didn’t do appears here because I made a mistake. By the time I released I had no interview which covered the fighting at Lae in 1943, I could not find a veteran of that campaign. The Australian War Memorial has allowed me to use excerpts from <em class="italic">A Record of Marathon Adventures in the New Guinea War</em>, the written account of Masamichi Kitamoto, translated by Nobuo Ohsaki.</p>
<a id="page_xii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Ack.vue?4e6a2d53